export default __webpack_public_path__ + "static/media/card-blog4.72a84c44.jpg";